export enum EventScheduleEnum {
    Weekdays = 0,
    Weekend = 1,
    Custom = 2,
}
export const EventScheduleMap: Record<number, string> = {
    [EventScheduleEnum.Weekdays]: 'Weekdays',
    [EventScheduleEnum.Weekend]: 'Weekend',
    [EventScheduleEnum.Custom]: 'Custom',
};
